<template>
  <div class="articlelistcontainer">
    <div class="pagetitle"><H3 class="title">新闻中心</H3></div>

    <el-table
      :data="tableData"
      style="width: 100%; margin-bottom: 30px"
      :row-class-name="tableRowClassName"
    >
      <el-table-column prop="id" label="序号" width="90" align="center" header-align="center"> </el-table-column>
      <el-table-column prop="title" label="新闻标题" header-align="left" >
          <template slot-scope="scope">
          <span
            style="cursor:pointer"
             @click="$router.push(`/showarticle/${scope.row.id}`)"
          >{{ scope.row.title }}</span>
        </template>
        </el-table-column>
      <el-table-column
        prop="updatetime"
        label="更新时间"
        width="200"
        align="center"
        header-align="center"
      >
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "ArticleList",
  data() {
    return {
      tableData: [],
    };
  },
  methods: {
    tableRowClassName() {},
  },
  mounted() {
    const url = "http://www.heyuemedical.com/Article/";
    this.axios.get(url).then((res) => {
      console.log(res);
      this.tableData = res.data;
    });
  },
};
</script>

<style>
.articlelistcontainer {
  width: 1200px;
  margin: 0 auto;
  min-height: 500px;
  /*background-color: #eee;*/
}
td,
th {
  font-size: 16px;
}
</style>